<template>
  <div id="stores">
    <div class="header flex-between">
      <div class="header-text">
        <h1>营销活动管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="querySearchBtn"
          >{{ searchBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="alterationVisible = true"
          >{{ insertBtnText }}</el-button
        >
        <!-- <el-button
          icon="iconfont icon-chuangjian1"
          @click="(createId = 2), nextBtn()"
          >{{ insertBtnText }}</el-button
        > -->
        <el-button
          v-if="jurisdiction.copy"
          icon="el-icon-edit-outline"
          @click="copy"
          >{{ copeBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="iconfont icon-xiugai1"
          @click="edit"
          >{{ modifyBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="openDeleteShow"
          >{{ deleteBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.toexamine"
          icon="iconfont"
          @click="checkBtnShow"
          >{{ examineBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.disable"
          icon="iconfont"
          @click="checkDisableShow"
          >{{ disableBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="lookList"
          >{{ lookBtnText }}</el-button
        >
      </div>
    </div>
    <!-- 创建-选择类型弹窗 -->
    <div class="alteration">
      <el-dialog
        width="18%"
        title="营销活动管理管理—创建"
        :modal-append-to-body="false"
        :visible.sync="alterationVisible"
        :close-on-click-modal="false"
      >
        <el-form size="mini" label-width="50px">
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="0"
              style="zoom: 110%"
              @change="radioChange"
              >单次营销活动</el-radio
            >
          </el-form-item>
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="1"
              style="zoom: 110%"
              @change="radioChange"
              >定时营销活动</el-radio
            >
          </el-form-item>
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="2"
              style="zoom: 110%"
              @change="radioChange"
              >消费行为触发营销活动</el-radio
            >
          </el-form-item>
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="100"
              style="zoom: 110%"
              @change="radioChange"
              >消费行为触发阶梯赠券营销活动</el-radio
            >
          </el-form-item>
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="3"
              style="zoom: 110%"
              @change="radioChange"
              >会员等级变动营销活动</el-radio
            >
          </el-form-item>
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="6"
              style="zoom: 110%"
              @change="radioChange"
              >扫码触发营销活动</el-radio
            >
          </el-form-item>
          <el-form-item>
            <el-radio
              v-model="createForm.label"
              :label="7"
              style="zoom: 110%"
              @change="radioChange"
              >品牌Friends扫码营销活动</el-radio
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="(alterationVisible = false), nextBtn()">{{
            nextBtnText
          }}</el-button>
          <el-button @click="alterationVisible = false">{{
            cancelButtonText
          }}</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form size="small" label-width="100px">
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item label="活动名称">
                <el-input v-model="config.campaignName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="活动类型">
                <el-select
                  v-model="config.compaignKind"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in activityType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select style="width: 100%" v-model="config.state">
                  <el-option label="所有" value=""></el-option>
                  <el-option label="已审核" value="0"></el-option>
                  <el-option label="待审核" value="1"></el-option>
                  <el-option label="已禁用" value="2"></el-option>
                  <el-option label="已完成" value="3"></el-option>
                  <el-option label="运行中" value="4"></el-option>
                  <el-option label="生效中" value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker
                  style="width: 57%"
                  v-model="dateValue"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行日期从">
                <el-date-picker
                    style="width: 57%"
                    v-model="executedateValue"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="centercard">
      <el-table
        size="small"
        class="table-style"
        border
        :height="isMore ? 'calc(100vh - 27.5rem)' : 'calc(100vh - 26rem)'"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
        @selection-change="handleSelectionChange"
        @select="handleSelectionCheck"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="活动编号" prop="campaignNo">
          <!-- <template slot-scope="scope">
            <div
            v-if="jurisdiction.modify"
              style="text-decoration: underline; color: skyblue"
              @click="lookMarketingNumber(scope.row)"
            >
              {{ scope.row.campaignNo }}
            </div>
            <div
            v-else
              style="text-decoration: underline; color: skyblue"
            >
              {{ scope.row.campaignNo }}
            </div>
          </template> -->
        </el-table-column>
        <el-table-column prop="campaignName" label="活动名称">
          <template slot-scope="scope">
            <div
              v-if="jurisdiction.look"
              style="text-decoration: underline; color: skyblue"
              @click="lookMarketingName(scope.row)"
            >
              {{ scope.row.campaignName }}
            </div>
            <div v-else style="text-decoration: underline; color: skyblue">
              {{ scope.row.campaignName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="活动类型">
          <template slot-scope="scope">
            {{
              scope.row.compaignKind == "0"
                ? "单次营销活动"
                : scope.row.compaignKind == "1"
                ? "定时营销活动"
                : scope.row.compaignKind == "2"
                ? "消费行为触发营销活动"
                : scope.row.compaignKind == "100"
                ? "消费行为触发阶梯赠券营销活动"
                : scope.row.compaignKind == "3"
                ? "会员注册活动"
                : scope.row.compaignKind == "4"
                ? "会员升级"
                : scope.row.compaignKind == "5"
                ? "会员降级"
                : scope.row.compaignKind == "6"
                ? "扫码触发营销活动"
                : scope.row.compaignKind == "7"
                ? "品牌Friends扫码营销活动"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.state == "0"
                ? "已审核"
                : scope.row.state == "1"
                ? "待审核"
                : scope.row.state == "2"
                ? "已禁用"
                : scope.row.state == "3"
                ? "已完成"
                : scope.row.state == "4"
                ? "运行中"
                : scope.row.state == "5"
                ? "生效中"
                : ""
            }}
            <!-- 状态 :  0 :已审核     1：待审核     2：已禁用    3：已完成   4：运行中 -->
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTimeStr" label="创建日期">
          <template slot-scope="scope">
            {{ scope.row.createTimeStr | dateFormats }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTimeStr" label="最后修改日期">
          <template slot-scope="scope">
            {{ scope.row.updateTimeStr | dateFormats }}
          </template>
        </el-table-column>
      </el-table>
      <div class="card-pagination">
        <el-alert
          v-if="config.total <= tableData.length && tableData.length > 0"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </div>
    </el-card>
    <!-- 查看弹窗 -->
    <!-- <singleMarketingDialog
      ref="singleMarketingDialogRef"
    ></singleMarketingDialog> -->

    <!-- 单次营销活动弹窗 -->
    <div class="alteration">
      <el-dialog
        width="50%"
        :destroy-on-close="true"
        :modal-append-to-body="false"
        :title="SingleTimeShowTitle"
        :visible.sync="createdEditSingleTimeShow"
        :close-on-click-modal="false"
      >
        <createdEditSingleTime
          @success="success"
          @close="createdEditSingleTimeShow = false"
          ref="singleTimeDialogRef"
        ></createdEditSingleTime>
      </el-dialog>
    </div>
    <!-- 定时营销活动—创建 -->
    <div class="alteration">
      <el-dialog
        :destroy-on-close="true"
        :modal-append-to-body="false"
        width="50%"
        :title="timingDialogTitle"
        :visible.sync="timingDialogShow"
        :close-on-click-modal="false"
      >
        <timingDialog
          @success="success()"
          @close="timingDialogShow = false"
          ref="timingDialogRef"
        ></timingDialog>
      </el-dialog>
    </div>
    <!-- 消费行为触发营销活动—创建 -->
    <div class="alteration">
      <el-dialog
        :modal-append-to-body="false"
        width="50%"
        :title="consumptionDialogTitle"
        :visible.sync="consumptionDialogShow"
        :close-on-click-modal="false"
      >
        <consumptionDialog
          @success="success"
          @close="consumptionDialogShow = false"
          ref="consumptionDialogRef"
        ></consumptionDialog>
      </el-dialog>
    </div>
    <!-- 消费行为触发阶梯赠券营销活动 -->
    <div class="alteration">
      <el-dialog
        :modal-append-to-body="false"
        width="50%"
        :title="spendingFullGiftDialogTitle"
        :visible.sync="spendingFullGiftDialogShow"
        :close-on-click-modal="false"
      >
        <consumptionFullGiftActivity
          @success="success"
          @close="spendingFullGiftDialogShow = false"
          ref="consumptionFullGiftRef"
        ></consumptionFullGiftActivity>
      </el-dialog>
    </div>
    <!-- <consumptionDialog ref="consumptionDialogRef"></consumptionDialog> -->
    <!-- 会员等级变动营销活动—创建 -->
    <div class="alteration">
      <el-dialog
        :modal-append-to-body="false"
        width="52%"
        :title="gradeChangeDialogTitle"
        :visible.sync="gradeChangeDialogShow"
        :close-on-click-modal="false"
        @close="createFormClosed"
      >
        <gradeChangeDialog
          @success="success"
          @close="gradeChangeDialogShow = false"
          ref="gradeChangeDialogRef"
        ></gradeChangeDialog>
      </el-dialog>
    </div>
    <!-- <gradeChangeDialog ref="gradeChangeDialogRef"></gradeChangeDialog> -->
    <!-- 扫码触发营销活动 -->
    <div class="alteration">
      <el-dialog
        width="50%"
        :modal-append-to-body="false"
        :title="scanCodeDialogTitle"
        :visible.sync="scanCodeDialogShow"
        :close-on-click-modal="false"
      >
        <scanCodeDialog
          @success="success"
          @close="scanCodeDialogShow = false"
          ref="scanCodeDialogRef"
        ></scanCodeDialog>
      </el-dialog>
    </div>
    <!-- 品牌Friends扫码营销活动 -->
    <div class="alteration">
      <el-dialog
        :modal-append-to-body="false"
        width="52%"
        :title="brandMarketingDialogTitle"
        :visible.sync="brandMarketingDialogShow"
        :close-on-click-modal="false"
        @close="createppFormClosed"
      >
        <brandMarketingDialog
          @success="success"
          @close="brandMarketingDialogShow = false"
          ref="brandMarketingDialogRef"
        ></brandMarketingDialog>
      </el-dialog>
    </div>
    <!-- <brandMarketingDialog ref="brandMarketingDialogRef"></brandMarketingDialog> -->
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除营销活动对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>营销活动?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteBtn()">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 禁用弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="禁用营销活动对话框"
        :visible.sync="disabledFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">禁用</span>营销活动?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="checkDisable()">确 定</el-button>
          <el-button @click="disabledFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 审核弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="审核营销活动对话框"
        :visible.sync="toExamineFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">审核</span>营销活动?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="checkBtn()">确 定</el-button>
          <el-button @click="toExamineFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 禁用可输入弹窗 -->

    <div class="inputdelete">
      <el-dialog
          :close-on-click-modal="false"
          width="20%"
          title="禁用营销活动对话框"
          :visible.sync="disabledInputFormVisible"
      >
        <div style="height: 30px;font-weight: 700">
          <el-form :inline="true"
              ref="newUploadForm"
          >
                <el-form-item label="是否取消待发放记录">
                  <el-checkbox v-model="futureFlag"></el-checkbox>
                </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="checkDisable()">确 定</el-button>
          <el-button @click="disabledInputFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>


  </div>
</template>
<script>
import { mapState } from "vuex";
// import singleMarketingDialog from "./singleMarketingDialog.vue";
import timingDialog from "@/components/timingDialog/index.vue";
import consumptionDialog from "@/components/consumptionDialog/index.vue";
import consumptionFullGiftActivity from "@/components/consumptionFullGiftActivity/index.vue";
// import gradeChangeDialog from "./gradeChangeDialog.vue";
import scanCodeDialog from "@/components/scanCodeDialog/index.vue";
// import brandMarketingDialog from "./brandMarketingDialog.vue";
import createdEditSingleTime from "@/components/singleTimeDialog/index.vue";
import gradeChangeDialog from "@/components/gradeChangeDialog/index.vue";
import brandMarketingDialog from "@/components/brandMarketingDialog/index.vue";
import {
  marketingActivitiesApi,
  marketingActLookApi,
  marketingDeleteApi,
  checkEnableApi,
  checkDisableApi,
} from "@/api/marketing";
export default {
  name: "centre",
  components: {
    //singleMarketingDialog,
    timingDialog,
    consumptionDialog,
    consumptionFullGiftActivity,
    gradeChangeDialog,
    scanCodeDialog,
    brandMarketingDialog,
    createdEditSingleTime,
  },
  props: ["visible"],
  data() {
    return {
      jurisdiction: {
        search: false,
        create: false,
        copy: false,
        modify: false,
        delete: false,
        toexamine: false,
        disable: false,
        look: false,
      },
      scanCodeDialogShow1: false,
      consumptionDialogShow1: false,
      timingDialogShow1: false,
      gradeChangeDialogShow1: false,
      brandMarketingDialogShow1: false,
      mask: false, //营销活动-单次营销活动—创建弹窗
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateValue: [],
      executedateValue: [],
      toExamineFormVisible: false, //审核弹窗
      disabledFormVisible: false, //禁用弹窗
      disabledInputFormVisible: false, //禁用可输入弹窗
      deleteFormVisible: false, //删除弹窗
      gradeChangeDialogShow: false, //
      gradeChangeDialogTitle: "", //
      brandMarketingDialogShow: false, //
      brandMarketingDialogTitle: "", //
      consumptionDialogShow: false, //消费行为触发营销活动弹窗
      consumptionDialogTitle: "", //消费行为触发营销活动标题
      spendingFullGiftDialogShow: false, //消费行为触发阶梯赠券营销活动弹窗
      spendingFullGiftDialogTitle: "", //消费行为触发阶梯赠券营销活动标题
      scanCodeDialogShow: false, //扫码触发营销活动标题
      scanCodeDialogTitle: "", //扫码触发营销活动标题
      timingDialogShow: false, //定时营销活动弹窗显示
      timingDialogTitle: "", //定时营销活动弹窗标题
      SingleTimeShowTitle: "", //单次活动弹窗标题
      isDisabled: false,
      loading: false,
      alterationVisible: false,
      labelPosition: "top",
      radio: "",
      futureFlag: false,
      SelectChang: {}, //选中的数据
      querySearch: {},
      //搜索
      activityTypeStr: "",
      activityType: [
        {
          value: "",
          label: "全部 ",
        },
        {
          value: 0,
          label: "单次营销活动",
        },
        {
          value: 1,
          label: "定时营销活动",
        },
        {
          value: 2,
          label: "消费行为触发营销活动",
        },
        {
          value: 100,
          label: "消费行为触发阶梯赠券营销活动",
        },
        {
          value: 3,
          label: "会员注册活动",
        },
        {
          value: 4,
          label: "会员升级",
        },
        {
          value: 5,
          label: "会员降级",
        },
        {
          value: 6,
          label: "扫码触发营销活动",
        },
        {
          value: 7,
          label: "品牌Friends扫码营销活动",
        },
      ],
      createForm: {
        label: "",
      },
      config: {
        pageNo: 1,
        pageSize: 50,
        total: 0,
        campaignName: "",
        state: "",
        createStartDay: undefined,
        createEndDay: undefined,
        executeStartTime: undefined,
        executeEndTime: undefined,
        pageNum: undefined,
      },
      tableData: [],
      handleChangeData: {},
      createId: undefined,
      createdEditSingleTimeShow: false,
      formData: {},
      fixedTopNum: "",
    };
  },
  computed: {
    isMore() {
      return this.tableData.length >= this.config.total;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    ...mapState([
      "searchBtnText",
      "insertBtnText",
      "copeBtnText",
      "modifyBtnText",
      "deleteBtnText",
      "disableBtnText",
      "examineBtnText",
      "lookBtnText",
      "confirmButtonText",
      "cancelButtonText",
      "nextBtnText",
    ]),
  },
  created() {
    this.tableList();
    let ManagementActivities = JSON.parse(
      localStorage.getItem("ManagementActivities")
    );
    for (let i = 0; i < ManagementActivities.length; i++) {
      if (ManagementActivities[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "审核") {
        this.jurisdiction.toexamine = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "禁用") {
        this.jurisdiction.disable = true;
        continue;
      }
      if (ManagementActivities[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
  },
  methods: {
    close() {
      this.timingDialogShow = false;
      this.createdEditSingleTimeShow = false;
      this.consumptionDialogShow = false;
      this.gradeChangeDialogShow = false;
      this.scanCodeDialogShow = false;
      this.brandMarketingDialogShow = false;
      // window.location.reload();
    },
    // 监听弹窗关闭事件
    createFormClosed() {
      this.$refs.gradeChangeDialogRef.createFormClosed();
      // this.$refs.gradeChangeDialogRef.createFormClosed()
    },
    createppFormClosed() {
      this.$refs.brandMarketingDialogRef.createppFormClosed();
    },
    edit() {
      if (this.SelectChang.campaignID) {
        this.lookMarketingNumber(this.SelectChang);
      } else {
        this.$message.info("请先选择一条数据后，在进行修改");
      }
    },
    copy() {
      if (this.SelectChang.campaignID) {
        switch (this.SelectChang.compaignKind) {
          case 0:
            this.SingleTimeShowTitle = "营销活动-单次营销活动—复制";
            this.createdEditSingleTimeShow = true;
            break;
          case 1:
            this.timingDialogTitle = "营销活动-定时营销活动—复制";
            this.timingDialogShow = true;
            break;
          case 2:
            this.consumptionDialogShow = true;
            this.consumptionDialogTitle = "消费行为触发营销活动—复制";
            break;
          case 100:
            this.spendingFullGiftDialogTitle =
              "消费行为触发阶梯赠券营销活动—复制";
            this.spendingFullGiftDialogShow = true;
            break;
          case 3:
          case 4:
          case 5:
            this.gradeChangeDialogShow = true;
            this.gradeChangeDialogTitle = "会员等级变动营销活动—复制";
            break;
          case 6:
            this.scanCodeDialogTitle = "营销活动-扫码触发营销活动—复制";
            this.scanCodeDialogShow = true;
            break;
          case 7:
            this.brandMarketingDialogShow = true;
            this.brandMarketingDialogTitle = "品牌Friends扫码营销活动—复制";
            break;
          default:
        }
        marketingActLookApi({ campaignID: this.SelectChang.campaignID }).then(
          (res) => {
            if (res.success) {
              // 单次营销活动
              if (res.data.compaignKind == 0) {
                this.$nextTick(() => {
                  res.flag = 0;
                  this.$refs.singleTimeDialogRef.parentHandleclick(res);
                });
              } else if (res.data.compaignKind == 1) {
                this.$nextTick(() => {
                  res.flag = 0;
                  this.$refs.timingDialogRef.parentHandleclick(res);
                });
              } else if (res.data.compaignKind == 2) {
                if (this.SelectChang.giftGiveMode === 0) {
                  this.$nextTick(() => {
                    res.flag = 0;
                    this.$refs.consumptionDialogRef.parentHandleclick(res);
                  });
                } else if (this.SelectChang.giftGiveMode === 1) {
                  this.$nextTick(() => {
                    this.$refs.consumptionFullGiftRef.getDetails(res, "add");
                  });
                }
              } else if (res.data.compaignKind == 6) {
                this.$nextTick(() => {
                  res.flag = 0;
                  this.$refs.scanCodeDialogRef.parentHandleclick(res);
                });
              } else if (res.data.presentedKind == 2) {
                this.$refs.singleTimeDialogRef.form.presentedObjID2 =
                  res.data.presentedObjID;
              } else if (res.data.presentedKind == 3) {
                this.$refs.singleTimeDialogRef.form.presentedObjID3 =
                  res.data.presentedObjID;
              } else if (
                res.data.compaignKind == 3 ||
                res.data.compaignKind == 4 ||
                res.data.compaignKind == 5
              ) {
                res.flag = 0;
                this.$nextTick(() => {
                  this.$refs.gradeChangeDialogRef.chulishuju(res);
                });
              } else if (res.data.compaignKind == 7) {
                res.flag = 0;
                this.$refs.brandMarketingDialogRef.chulishuju6(res);
              } else {
                this.$refs.singleTimeDialogRef.form.presentedObjID4 =
                  res.data.presentedObjID;
              }
            }
          }
        );
      } else {
        this.$message.info("请先选择一条数据后，在进行复制");
      }
    },
    //隐藏弹窗，刷新列表页
    success() {
      this.timingDialogShow = false;
      this.createdEditSingleTimeShow = false;
      this.spendingFullGiftDialogShow = false;
      this.consumptionDialogShow = false;
      this.gradeChangeDialogShow = false;
      this.scanCodeDialogShow = false;
      this.brandMarketingDialogShow = false;
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.tableList();
      // window.location.reload();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    handleSelectionCheck(selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    // 条件查询
    querySearchBtn() {
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.tableList();
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 列表数据
    tableList() {
      if (this.dateValue && this.dateValue.length > 0) {
        this.config.createStartDay = this.renderTime(
          this.dateValue[0]
        ).substring(0, 10);
        this.config.createEndDay = this.renderTime(this.dateValue[1]).substring(
          0,
          10
        );
      } else {
        this.config.createStartDay = "";
        this.config.createEndDay = "";
      }
      if (this.executedateValue && this.executedateValue.length > 0) {
        this.config.executeStartTime = this.renderTime(
            this.executedateValue[0]
        ).substring(0, 10);
        this.config.executeEndTime = this.renderTime(this.executedateValue[1]).substring(
            0,
            10
        );
      } else {
        this.config.executeStartTime = "";
        this.config.executeEndTime = "";
      }
      let giftGiveMode = null;
      let compaignKind = this.config.compaignKind;
      if (this.config.compaignKind == 2) {
        giftGiveMode = 0;
      } else if (this.config.compaignKind == 100) {
        compaignKind = 2;
        giftGiveMode = 1;
      }
      let queryInfo = {
        campaignName: this.config.campaignName,
        compaignKind: compaignKind,
        state: this.config.state,
        createStartDay: this.config.createStartDay,
        createEndDay: this.config.createEndDay,
        executeStartTime: this.config.executeStartTime,
        executeEndTime: this.config.executeEndTime,
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
        giftGiveMode,
      };
      marketingActivitiesApi(require("qs").stringify(queryInfo)).then((res) => {
        if (res.message == "success") {
          if (this.config.pageNo == 1) this.tableData = [];
          res.data.list.forEach((item) => {
            if (item.giftGiveMode === 1) item.compaignKind = 100;
          });
          this.tableData = this.tableData.concat(res.data.list);
          this.config.pageSize = res.data.pageSize;
          this.config.total = res.data.total;
          this.loading = false;
          this.config.pageNum = res.data.pageNum;
        }
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.tableList();
      }, 500);
    },
    // 创建弹窗
    // 复制
    // 修改
    // 删除
    openDeleteShow() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          showClose: true,
          message: "请选择数据,再删除!",
          type: "warning",
        });
      } else {
        this.deleteFormVisible = true;
      }
    },
    deleteBtn() {
      marketingDeleteApi({
        campaignID: this.SelectChang.campaignID,
      }).then((res) => {
        if (res.success) {
          this.$message.success("删除成功!");
          this.querySearchBtn();
          this.deleteFormVisible = false;
          this.disabledInputFormVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    checkBtnShow() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          showClose: true,
          message: "请选择数据,再操作!",
          type: "warning",
        });
      } else if (this.SelectChang.state == 1) {
        this.toExamineFormVisible = true;
      } else {
        this.$message({
          showClose: true,
          message: "只能对待审核数据进行审核操作！！！",
          type: "warning",
        });
      }
    },
    // 审核
    checkBtn() {
      checkEnableApi({ campaignID: this.SelectChang.campaignID }).then(
        (res) => {
          if (res.success) {
            this.$message.success("审核通过!");
            this.querySearchBtn();
            this.toExamineFormVisible = false;
          }
        }
      );
    },
    checkDisableShow() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          showClose: true,
          message: "请选择数据,再操作!",
          type: "warning",
        });
      } else {

        if (this.SelectChang.campaignID) {
          if (this.SelectChang.compaignKind==0 || this.SelectChang.compaignKind==1) {
            this.disabledFormVisible = true;
          }else{
            this.disabledInputFormVisible = true;
          }
        }
      }
    },
    // 禁用
    checkDisable() {

      checkDisableApi({ campaignID: this.SelectChang.campaignID ,futureFlag:this.futureFlag}).then(
        (res) => {
          if (res.success) {
            this.$message.success("禁用成功!");
            this.querySearchBtn();
            this.disabledFormVisible = false;
            this.disabledInputFormVisible = false;
          }
        }
      );
    },
    // 禁用
    checkInputDisable() {
      checkDisableApi({ campaignID: this.SelectChang.campaignID,futureFlag:this.futureFlag }).then(
          (res) => {
            if (res.success) {
              this.$message.success("禁用成功!");
              this.querySearchBtn();
              this.disabledInputFormVisible = false;
            }
          }
      );
    },
    // 查看
    lookList() {
      if (this.SelectChang.campaignID) {
        this.lookMarketingName(this.SelectChang);
      } else {
        this.$message.info("请先选择一条数据后，在进行查看");
      }
    },
    // 下一步
    nextBtn() {
      switch (this.createId) {
        case 0:
          // this.mask = true;
          this.createdEditSingleTimeShow = true;
          this.SingleTimeShowTitle = "营销活动-单次营销活动—创建";
          this.$nextTick(() => {
            this.$refs.singleTimeDialogRef.parentHandleclick();
          });
          break;
        case 1:
          this.timingDialogShow = true;
          this.timingDialogTitle = "定时营销活动—创建";
          this.$nextTick(() => {
            this.$refs.timingDialogRef.parentHandleclick();
          });
          break;
        case 2:
          this.consumptionDialogShow = true;
          this.consumptionDialogTitle = "消费行为触发营销活动—创建";
          this.$nextTick(() => {
            let data = {
              flag: 0,
            };
            this.$refs.consumptionDialogRef.parentHandleclick(data);
          });
          break;
        case 100:
          this.spendingFullGiftDialogTitle =
            "消费行为触发阶梯赠券营销活动—创建";
          this.spendingFullGiftDialogShow = true;
          this.$nextTick(() => {
            this.$refs.consumptionFullGiftRef.getDetails(undefined, "add");
          });
          break;
        case 3:
        case 4:
        case 5:
          this.gradeChangeDialogShow = true;
          this.gradeChangeDialogTitle = "会员等级变动营销活动—创建";
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.gradeChangeDialogRef.parentHandleclick();
            }, 50);
          });
          break;
        case 6:
          this.scanCodeDialogShow = true;
          this.scanCodeDialogTitle = "扫码触发营销活动—创建";
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.scanCodeDialogRef.parentHandleclick();
            }, 50);
          });
          break;
        case 7:
          this.brandMarketingDialogShow = true;
          this.brandMarketingDialogTitle = "品牌Friends扫码营销活动—创建";
          break;
        default:
      }
    },
    radioChange(index) {
      this.createId = index;
    },
    // table修改
    lookMarketingNumber(index) {
      switch (index.compaignKind) {
        case 0:
          this.SingleTimeShowTitle = "营销活动-单次营销活动—修改";
          this.createdEditSingleTimeShow = true;
          break;
        case 1:
          this.timingDialogTitle = "定时营销活动—修改";
          this.timingDialogShow = true;
          break;
        case 2:
          this.consumptionDialogShow = true;
          this.consumptionDialogTitle = "消费行为触发营销活动—修改";
          break;
        case 100:
          this.spendingFullGiftDialogTitle =
            "消费行为触发阶梯赠券营销活动—修改";
          this.spendingFullGiftDialogShow = true;
          break;
        case 3:
        case 4:
        case 5:
          this.gradeChangeDialogShow = true;
          this.gradeChangeDialogTitle = "会员等级变动营销活动—修改";
          break;
        case 6:
          this.scanCodeDialogTitle = "扫码触发营销活动—修改";
          this.scanCodeDialogShow = true;
          break;
        case 7:
          this.brandMarketingDialogShow = true;
          this.brandMarketingDialogTitle = "品牌Friends扫码营销活动—修改";
          break;
        default:
      }
      marketingActLookApi({ campaignID: index.campaignID }).then((res) => {
        if (
          res.data.compaignKind == 3 ||
          res.data.compaignKind == 4 ||
          res.data.compaignKind == 5
        ) {
          res.flag = 2;
          this.$nextTick(() => {
            this.$refs.gradeChangeDialogRef.chulishuju(res);
          });
        } else if (res.data.compaignKind == 0) {
          res.flag = 2;
          this.$nextTick(() => {
            this.$refs.singleTimeDialogRef.parentHandleclick(res);
          });
        } else if (res.data.compaignKind == 2) {
          if (index.giftGiveMode === 0) {
            res.flag = 2;
            this.$nextTick(() => {
              this.$refs.consumptionDialogRef.parentHandleclick(res);
            });
          } else if (index.giftGiveMode === 1) {
            this.$nextTick(() => {
              this.$refs.consumptionFullGiftRef.getDetails(res, "edit");
            });
          }
        } else if (res.data.compaignKind == 1) {
          res.flag = 2;
          this.$nextTick(() => {
            this.$refs.timingDialogRef.parentHandleclick(res);
          });
        } else if (res.data.compaignKind == 6) {
          res.flag = 2;
          this.$nextTick(() => {
            this.$refs.scanCodeDialogRef.parentHandleclick(res);
          });
        } else if (res.data.compaignKind == 7) {
          res.flag = 2;
          this.$refs.brandMarketingDialogRef.chulishuju6(res);
        }
      });
    },
    // table表格里面的查看
    lookMarketingName(index) {
      switch (index.compaignKind) {
        case 0:
          this.SingleTimeShowTitle = "营销活动-单次营销活动—查看";
          this.createdEditSingleTimeShow = true;
          break;
        case 1:
          this.timingDialogTitle = "定时营销活动—查看";
          this.timingDialogShow = true;
          break;
        case 2:
          this.consumptionDialogShow = true;
          this.consumptionDialogTitle = "消费行为触发营销活动—查看";
          break;
        case 100:
          this.spendingFullGiftDialogTitle =
            "消费行为触发阶梯赠券营销活动—查看";
          this.spendingFullGiftDialogShow = true;
          break;
        case 3:
        case 4:
        case 5:
          this.gradeChangeDialogShow = true;
          this.gradeChangeDialogTitle = "会员等级变动营销活动—查看";
          break;
        case 6:
          this.scanCodeDialogTitle = "扫码触发营销活动—查看";
          this.scanCodeDialogShow = true;
          break;
        case 7:
          this.brandMarketingDialogShow = true;
          this.brandMarketingDialogTitle = "品牌Friends扫码营销活动—查看";
          break;
        default:
      }
      marketingActLookApi({ campaignID: index.campaignID }).then((res) => {
        if (res.success) {
          // 单次营销活动
          if (res.data.compaignKind == 0) {
            this.$nextTick(() => {
              res.flag = 3;
              this.$refs.singleTimeDialogRef.parentHandleclick(res);
            });
          } else if (res.data.compaignKind == 1) {
            this.$nextTick(() => {
              res.flag = 3;
              this.$refs.timingDialogRef.parentHandleclick(res);
            });
          } else if (res.data.compaignKind == 2) {
            if (index.giftGiveMode === 0) {
              this.$nextTick(() => {
                res.flag = 3;
                this.$refs.consumptionDialogRef.parentHandleclick(res);
              });
            } else if (index.giftGiveMode === 1) {
              this.$nextTick(() => {
                this.$refs.consumptionFullGiftRef.getDetails(res, "look");
              });
            }
          } else if (res.data.compaignKind == 6) {
            this.$nextTick(() => {
              res.flag = 3;
              this.$refs.scanCodeDialogRef.parentHandleclick(res);
            });
          } else if (
            res.data.compaignKind == 3 ||
            res.data.compaignKind == 4 ||
            res.data.compaignKind == 5
          ) {
            res.flag = 3;
            this.$nextTick(() => {
              this.$refs.gradeChangeDialogRef.chulishuju(res);
            });
          } else if (res.data.compaignKind == 7) {
            res.flag = 3;
            this.$refs.brandMarketingDialogRef.chulishuju6(res);
          } else {
            this.$refs.singleTimeDialogRef.form.presentedObjID4 =
              res.data.presentedObjID;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#stores {
  // height: 1350px;
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
.push-button {
  background-color: #e9e7d3;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .alteration {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
::v-deep {
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .inputdelete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    //.el-form-item__content {
    //  line-height: 0px;
    //}
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
.mask1 {
  padding: 80px 0 10vh 0;
  height: 100vh;
  position: fixed;
  overflow: scroll;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.4);
  .title {
    background: #f3f1dd;
    font-size: 0.875rem;
    font-weight: 700;
    color: #6c6937;
    padding: 1.25rem 1.25rem 0.625rem;
  }
}
.mask1 > div:first-child {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.mask {
  position: fixed;
  padding: 10vh 0 10vh 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.4);
  .title {
    background: #f3f1dd;
    font-size: 0.875rem;
    font-weight: 700;
    color: #6c6937;
    padding: 1.25rem 1.25rem 0.625rem;
  }
}
.contentBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.box {
  background: #ffffff;
  width: 50%;
  height: 90vh;
  overflow-y: scroll;
}
.box::-webkit-scrollbar {
  display: none;
}
</style>
